import React from "react";
import styles from "./ToggleSwitch.module.scss";
const ToggleSwitch = ({ isOn, handleToggle, onColor, id }) => {
  const switchId = id || "toggleswitch";
  return (
    <div className={styles.margintop}>
      <input
        checked={isOn}
        onChange={handleToggle}
        className={styles.reactswitchcheckbox}
        id={switchId}
        type="checkbox"
      />
      <label
        style={{ background: isOn && onColor }}
        className={styles.reactswitchlabel}
        htmlFor={switchId}
      >
        <span className={styles.reactswitchbutton} />
        <span
          className={
            isOn === true ? styles.reactswitchtext : styles.reactswitchtextright
          }
        >
          {isOn === true ? "on" : "off"}
        </span>
      </label>
    </div>
  );
};

export default ToggleSwitch;
